module.exports = __webpack_public_path__ + "img/mobilitybudget.6c60e56b.svg";